import { put, takeEvery, call } from "redux-saga/effects";
import { ERROR_MESSAGE } from "common/constants";
import { message } from "antd";
import {
  fetchGetProjectSetting,
  fetchLoading,
  fetchUpdateCommonState
} from "./actions";
import { fetchApi } from "utils/fetchApi";
import { CommonActionTypes } from "./types";


function* handleFetchQueryTenantFontPageStyleByDomain(action: ReturnType<typeof fetchGetProjectSetting>) {
  try {
    yield put(fetchLoading({showB: true, text: ""}));    
    const res = yield call(fetchApi, "post", `${"api/platform-manager/api/manager/font-page-meta-info/queryTenantFontPageStyleByDomain"}`, {...action.payload, hideError: true});

    if (res) {

      if (res.result === 0 && Object.keys(res.data).length && res.data.formatTemplateJson) {
        const projectSetting =  JSON.parse(res.data.formatTemplateJson);
        document.title = projectSetting.loginBrowserTitle;

        yield put(fetchUpdateCommonState({
          projectSetting
        }));    
      }

    }
       
  } catch(err) {
    // message.error(err instanceof Error ? err.stack! : ERROR_MESSAGE);
  }
  yield put(fetchLoading({showB: false, text: ""}));
}


function* commonSaga() {
  yield takeEvery(CommonActionTypes.FETCH_GET_PROJECT_SETTING, handleFetchQueryTenantFontPageStyleByDomain);
}

export default commonSaga;
